import type { ReactNode } from "react";
import { Lock } from "lucide-react";
import { useCanAccess, useGetIdentity, useRecordContext } from "ra-core";

/** True when the current user may change the record: assigned agent or administrator (mirrors RLS can_edit_owned). */
export const useCanEditOwned = () => {
  const record = useRecordContext();
  const { identity, isPending } = useGetIdentity();
  const { canAccess: isAdmin, isPending: adminPending } = useCanAccess({
    resource: "sales",
    action: "list",
  });
  if (!record || record.id == null) return true; // create form
  if (isPending || adminPending) return true;
  if (isAdmin) return true;
  return record.sales_id != null && record.sales_id === identity?.id;
};

export const ReadOnlyNotice = () => (
  <div className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200">
    <Lock className="h-4 w-4 shrink-0" />
    <span>
      Read only: this account is assigned to another agent. Only the assigned
      agent or an administrator can save changes or delete it.
    </span>
  </div>
);

/** Renders the form toolbar for owners/admins, a read-only notice for everyone else. */
export const OwnerToolbar = ({ children }: { children: ReactNode }) =>
  useCanEditOwned() ? <>{children}</> : <ReadOnlyNotice />;
